import { Box, Typography } from "@mui/material";
import Personnummer from "personnummer";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import {
  EmailRegExp,
  NationalReserveIdentityRegExp,
  PhoneNumberRegExp,
  ValidPostalRegExp,
  ValidTextRegExp,
  VastmanlandPersonalDataLink,
  PostalCodeLength,
} from "../../../Constant";
import MyContext from "../../../contexts/MyContext";
import { FormWrapper } from "../FormWrapper";
import { MyIdentityNumberField } from "../../../components/my-identity-number-field/MyIdentityNumberField";
import { MyCheckbox } from "../../../components/my-checkbox/MyCheckbox";
import ClaimApiService from "../../../adapters/xhr/ClaimApiService";
import { formatDepartureDate, toBase64 } from "../../../Utils";
import { getConfirmation } from "../../../components/my-confirmation-dialog/MyConfirmationDialog";
import { TrainTheme } from "../../../infrastructure/TrainThemeProvider";
import PostalCodeApiService from "../../../adapters/xhr/PostalCodeApiService";

export const TicketForm2 = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const [emailValueErr, setEmailValueErr] = useState("");
  const [firstnameValueErr, setFirstnameValueErr] = useState("");
  const [surnameValueErr, setSurnameValueErr] = useState("");
  const [streetNameAndNumberValueErr, setStreetNameAndNumberValueErr] = useState("");
  const [postalCodeValueErr, setPostalCodeValueErr] = useState("");
  const [cityValueErr, setCityValueErr] = useState("");
  const [personalIDValueErr, setPersonalIDValueErr] = useState("");
  const [mobileNumberValueErr, setMobileNumberValueErr] = useState("");
  const [declareInformationErr, setDeclareInformationErr] = useState("");

  const [cityDisabled, setCityDisabled] = useState(false);
  const [validPostalCode, setValidPostalCode] = useState(false);

  const [phoneChanged, setPhoneChanged] = useState(false);
  const [emailChanged, setEmailChanged] = useState(false);

  const getCity = async () => {
    let response = await PostalCodeApiService.getCity(myContext.postalCode?.trim().replace(/\s/g, ""));
    if (response.isSuccess) {
      if (response.data === "") {
        setPostalCodeValueErr("you_have_entered_incorrect_zip_code");
        setValidPostalCode(false);
      } else if (response.data === null) {
        setPostalCodeValueErr("");
        setValidPostalCode(true);
      } else {
        setPostalCodeValueErr("");
        setValidPostalCode(true);
        myContext.changeCity(response.data);
        setCityDisabled(true);
      }
    }
  };

  useEffect(() => {
    if (emailChanged && myContext.email) validateEmail();
    else setEmailValueErr("");
  }, [myContext.email]);

  useEffect(() => {
    if (phoneChanged && myContext.mobileNumber) validatePhone();
    else setMobileNumberValueErr("");
  }, [myContext.mobileNumber]);

  useEffect(() => {
    if (myContext.postalCode) {
      myContext.changeCity("");
      setCityDisabled(false);
      setCityValueErr("");
      let validPostal = new RegExp(ValidPostalRegExp);
      if (validPostal.test(myContext.postalCode.trim())) {
        getCity();
      } else {
        setPostalCodeValueErr("you_have_entered_incorrect_zip_code");
      }
    } else setPostalCodeValueErr("");
  }, [myContext.postalCode]);

  const validateEmail = () => {
    let validEmail = new RegExp(EmailRegExp);
    if (!myContext.email.trim()) {
      setEmailValueErr("email_must_be_specified");
      return false;
    } else if (!validEmail.test(myContext.email.trim())) {
      setEmailValueErr("email_address_is_incorrect");
      return false;
    } else setEmailValueErr("");
    return true;
  };

  const validatePhone = () => {
    let validPhoneNumber = new RegExp(PhoneNumberRegExp);
    if (!myContext.mobileNumber.trim()) {
      setMobileNumberValueErr("mobile_number_must_be_specified");
      return false;
    } else if (!validPhoneNumber.test(myContext.mobileNumber.trim())) {
      setMobileNumberValueErr("entered_invalid_phonenumber");
      return false;
    } else setMobileNumberValueErr("");
    return true;
  };

  const validate = async () => {
    let isValid = true;

    let validNationalReserveIdentity = new RegExp(NationalReserveIdentityRegExp);
    let validPostal = new RegExp(ValidPostalRegExp);

    if (!validateEmail()) isValid = false;

    if (!myContext.firstname.trim()) {
      setFirstnameValueErr("first_name_must_be_specified");
      isValid = false;
    } else setFirstnameValueErr("");
    if (!myContext.surname.trim()) {
      setSurnameValueErr("surname_must_be_specified");
      isValid = false;
    } else setSurnameValueErr("");

    if (!myContext.personalID) {
      setPersonalIDValueErr("personal_id_must_be_specified");
      isValid = false;
    } else if (!Personnummer.valid(myContext.personalID) && !validNationalReserveIdentity.test(myContext.personalID.trim())) {
      setPersonalIDValueErr("invalid_person_id");
      isValid = false;
    } else setPersonalIDValueErr("");

    if (!myContext.streetNameAndNumber.trim()) {
      setStreetNameAndNumberValueErr("street_name_and_number_must_be_specified");
      isValid = false;
    } else setStreetNameAndNumberValueErr("");

    if (!myContext.city.trim()) {
      setCityValueErr("city_must_be_specified");
      isValid = false;
    } else setCityValueErr("");

    if (!myContext.postalCode.trim()) {
      setPostalCodeValueErr("postal_code_must_be_specified");
      isValid = false;
    } else if (validPostalCode == false || !validPostal.test(myContext.postalCode.trim())) {
      setPostalCodeValueErr("you_have_entered_incorrect_zip_code");
      isValid = false;
    } else setPostalCodeValueErr("");

    if (!validatePhone()) isValid = false;

    if (isValid) await submit();
  };

  const submit = async () => {
    let isValid = true;
    if (!myContext.declareInformation) {
      setDeclareInformationErr("ensure_info");
      isValid = false;
    } else {
      setDeclareInformationErr("");
    }
    if (isValid) {
      let claimReceipts = [];
      if (
        !myContext.distance?.isShortTrain &&
        (myContext.foodTotalCost || (myContext.foodReceipt && myContext.foodReceipt.length > 0))
      ) {
        let foodReceipt = {
          id: "00000000-0000-0000-0000-000000000000",
          claimId: "00000000-0000-0000-0000-000000000000",
          receiptType: {
            id: "00000000-0000-0000-0000-000000000000",
            name: "Food",
          },
          transportationType: 0,
          totalCost: Number(myContext.foodTotalCost),
          fromAddress: "string",
          toAddress: "string",
          distance: 120,
          receiptAttachments: await Promise.all(
            myContext.foodReceipt.map(async (receipt) => {
              return {
                id: "00000000-0000-0000-0000-000000000000",
                receiptId: "00000000-0000-0000-0000-000000000000",
                file: await toBase64(receipt),
                fileName: receipt.name,
              };
            })
          ),
        };
        claimReceipts.push(foodReceipt);
      }
      if (myContext.numberOfKmDriven || myContext.transportTotalCost || (myContext.transportReceipt && myContext.transportReceipt.length > 0)) {
        let transportReceipt = {
          id: "00000000-0000-0000-0000-000000000000",
          claimId: "00000000-0000-0000-0000-000000000000",
          receiptType: {
            id: "00000000-0000-0000-0000-000000000000",
            name: "Transportation",
          },
          transportationType: myContext.transportationType,
          totalCost: Number(myContext.transportTotalCost),
          fromAddress: myContext.fromAddress,
          toAddress: myContext.toAddress,
          // registrationNumber: myContext.registrationNumber,
          distance: myContext.numberOfKmDriven != null ? Number(myContext.numberOfKmDriven) : 0,
          receiptAttachments: await Promise.all(
            myContext.transportReceipt.map(async (receipt) => {
              return {
                id: "00000000-0000-0000-0000-000000000000",
                receiptId: "00000000-0000-0000-0000-000000000000",
                file: await toBase64(receipt),
                fileName: receipt.name,
              };
            })
          ),
        };
        claimReceipts.push(transportReceipt);
      }
      if (
        !myContext.distance?.isShortTrain &&
        (myContext.accommodationTotalCost || (myContext.accommodationReceipt && myContext.accommodationReceipt.length > 0))
      ) {
        let accommodationReceipt = {
          id: "00000000-0000-0000-0000-000000000000",
          claimId: "00000000-0000-0000-0000-000000000000",
          receiptType: {
            id: "00000000-0000-0000-0000-000000000000",
            name: "Extra",
          },
          transportationType: 0,
          totalCost: Number(myContext.accommodationTotalCost),
          fromAddress: "string",
          toAddress: "string",
          distance: 120,
          receiptAttachments: await Promise.all(
            myContext.accommodationReceipt.map(async (receipt) => {
              return {
                id: "00000000-0000-0000-0000-000000000000",
                receiptId: "00000000-0000-0000-0000-000000000000",
                file: await toBase64(receipt),
                fileName: receipt.name,
              };
            })
          ),
        };
        claimReceipts.push(accommodationReceipt);
      }
      let result = await ClaimApiService.create({
        id: "00000000-0000-0000-0000-000000000000",
        customer: {
          id: "00000000-0000-0000-0000-000000000000",
          firstName: myContext.firstname.trim(),
          surName: myContext.surname.trim(),
          city: myContext.city?.trim(),
          postalCode: myContext.postalCode?.trim().replace(/\s/g, ""),
          streetNameAndNumber: myContext.streetNameAndNumber?.trim(),
          identityNumber: myContext.personalID?.toUpperCase().trim(),
          mobileNumber: myContext.mobileNumber.trim(),
          email: myContext.email.trim(),
        },
        ticketNumber: myContext.biljettnummerValue?.toUpperCase().trim(),
        ticketType: myContext.ticketType,
        ticketId: myContext.ticketId,
        departureStationId: myContext.departureStation?.key,
        arrivalStationId: myContext.arrivalStation?.key,
        departureDate: `${formatDepartureDate(myContext.departureDate, myContext.departureTime).toISOString()}`,
        comment: myContext.otherComments,
        status: 0,
        trainNumber: myContext.distance?.trafikverketTrainId ? Number(myContext.distance?.trafikverketTrainId) : 0,
        refundType: {
          id: "00000000-0000-0000-0000-000000000000",
          name: myContext.refundType,
        },
        claimReceipts: claimReceipts,
        otherTicketTypeValue: myContext.otherTicketTypeValue,
      });
      if (!result.isSuccess) {
        let message = t("refresh_page_message");
        if (result.errorMessage == "max_number_of_claims_reached") {
          message = t("max_number_of_claims_reached");
        }
        const confirmed = await getConfirmation({
          title: t("error"),
          message: message,
          theme: TrainTheme,
        });
        if (!confirmed) window.location.reload();
      } else {
        myContext.changeCaseNumber(result.data);
        myContext.changeActiveSlide((myContext.activeSlide += 1));
        myContext.resetState();
      }
    }
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <React.Fragment>
          <FormWrapper continueButtonLabel={t("send_in_application")} onContinue={validate} number={`2/2`} heading={`${t("personal_info")}`}>
            <MyTextField
              required={true}
              autoComplete="given-name"
              value={context.firstname}
              label={t("firstname")}
              userFieldName={true}
              maxLength={40}
              helperText={t(firstnameValueErr)}
              onChange={context.changeFirstname}
              regExp={ValidTextRegExp}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <MyTextField
              required={true}
              autoComplete="family-name"
              value={context.surname}
              regExp={ValidTextRegExp}
              label={t("surname")}
              userFieldName={true}
              maxLength={69}
              helperText={t(surnameValueErr)}
              onChange={context.changeSurname}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <MyTextField
              required={true}
              value={context.streetNameAndNumber}
              regExp={ValidTextRegExp}
              label={t("street_name_and_number")}
              userFieldName={true}
              helperText={t(streetNameAndNumberValueErr)}
              onChange={context.changeStreetNameAndNumber}
              maxLength={35}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <MyTextField
              required={true}
              value={context.postalCode}
              label={t("postal_code")}
              inputMode="numeric"
              regExp={"^[0-9\\s]{0,6}$"}
              maxLength={PostalCodeLength}
              userFieldName={true}
              helperText={t(postalCodeValueErr)}
              onChange={context.changePostalCode}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <MyTextField
              required={true}
              disabled={cityDisabled}
              value={context.city}
              regExp={ValidTextRegExp}
              label={t("city")}
              userFieldName={true}
              helperText={t(cityValueErr)}
              onChange={context.changeCity}
              maxLength={35}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <MyIdentityNumberField
              required={true}
              label={t("personal_identifications_number")}
              userFieldName={true}
              helperText={t(personalIDValueErr)}
              value={context.personalID}
              onChange={context.changePersonalID}
              placeholder={t("personal_id_format")}
              inputMode="numeric"
              mask="########-####"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <MyTextField
              required={true}
              value={context.mobileNumber}
              maxLength={15}
              autoComplete="tel"
              regExp={ValidTextRegExp}
              label={t("mobile_number")}
              type={"tel"}
              userFieldName={true}
              helperText={t(mobileNumberValueErr)}
              onChange={(e) => {
                setPhoneChanged(true);
                context.changeMobileNumber(e);
              }}
              inputMode="numeric"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <MyTextField
              required={true}
              value={context.email}
              autoComplete="email"
              maxLength={100}
              regExp={ValidTextRegExp}
              label={t("email")}
              userFieldName={true}
              helperText={t(emailValueErr)}
              onChange={(e) => {
                setEmailChanged(true);
                context.changeEmail(e);
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
              className="margin bottom-0"
            />
            <MyCheckbox
              label={t("declare_information")}
              helperText={t(declareInformationErr)}
              checked={context.declareInformation}
              onChange={context.changeDeclareInformation}
              className="margin top-1"
              style={{ marginBottom: "0.5rem" }}
            />
            <Typography sx={{ flex: "1 1 100%" }} id="tableTitle" component="p">
              {t("read_about_how_data_processed")}
              <Box style={{ width: "100%" }} component="a" color="primary.main" target="_blank" href={VastmanlandPersonalDataLink}>
                {t("read_about_how_data_processed_link")}
              </Box>
            </Typography>
          </FormWrapper>
        </React.Fragment>
      )}
    </MyContext.Consumer>
  );
};
